import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import useSmoothScroll from "@/hooks/useSmoothScroll";
import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import WhyUs from "@/components/sections/WhyUs";
import HowItWorks from "@/components/sections/HowItWorks";
import Gallery from "@/components/sections/Gallery";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import FloatingCTA from "@/components/sections/FloatingCTA";
import CookieConsent from "@/components/CookieConsent";
import { PoliticaConfidentialitate, PoliticaCookies, TermeniConditii } from "@/pages/legal/LegalPages";

const Home = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <WhyUs />
      <HowItWorks />
      <Gallery />
      <Testimonials />
      <FAQ />
      <Contact />
    </main>
    <Footer />
    <FloatingCTA />
  </>
);

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView(), 80);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  useSmoothScroll();

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App bg-white text-slate-900 overflow-x-hidden">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/politica-confidentialitate" element={<PoliticaConfidentialitate />} />
          <Route path="/politica-cookies" element={<PoliticaCookies />} />
          <Route path="/termeni-si-conditii" element={<TermeniConditii />} />
        </Routes>
        <CookieConsent />
      </div>
    </BrowserRouter>
  );
}

export default App;
